const mdfeRoutes = [
  {
    path: '/mdfe/consultar',
    name: 'mdfe.consultar',
    component: () => import('../views/mdfe/Consultar.vue'),
  },
  {
    path: '/mdfe/enviar/:id?',
    name: 'mdfe.enviar',
    component: () => import('../views/mdfe/Enviar.vue'),
  },
];

export default mdfeRoutes;
